// Shim re-export to preserve existing import path
// The auth command has been folderized under ./auth/
export { authCommand } from "./auth/index.js";
